export const aos = () => {
    const inner = document.querySelector(".kvSec__inner");

    // Delay the fade-in for kvSec__inner by 2 seconds
    if (inner) {
        setTimeout(() => {
            inner.style.animation = "fadeIn 1s ease-in-out forwards";
        }, 2000);
    }

    // Select all figures except figureKV
    const figures = document.querySelectorAll("figure:not(.kvSec__figure)");

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add("fadeInUp");
                observer.unobserve(entry.target); // Stop observing after animation runs once
            }
        });
    }, { threshold: 0.3 });

    figures.forEach(figure => observer.observe(figure));

}